import React from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm, formValueSelector } from 'redux-form';

import Header from 'components/shared/Header';
import EmergencyContacts from './EmergencyContacts';
import Pets from './Pets';
import OtherOccupants from './OtherOccupants';
import AddDocumentOfProofs from './AddDocumentOfProofs';
import Vehicles from 'components/landlord_app/applications/ManualApplicantDrawer/Vehicles';
import AddressFormFields from 'components/shared/AddressFormFields';
import LandlordReferences from 'components/landlord_app/applications/ManualApplicantDrawer/LandlordReferences';
import PersonalReferences from 'components/landlord_app/applications/ManualApplicantDrawer/PersonalReferences';

import RentalHistoryQuestions from './RentalHistoryQuestions';
import PersonalDetails from '../components/PersonalDetails';
import CurrentOccupation from './CurrentOccupation/index';
import validate from 'components/tenant_application/validate';
import { muiThemeNext } from 'helpers/MUIFiles';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { AccentColor } from 'helpers/AccentColorHelper';

let ManualApplicantForm = class extends React.Component {
  render() {
    const { handleSubmit } = this.props;

    return (
      <MuiThemeProvider theme={muiThemeNext(AccentColor())}>
        <div style={{ margin: 'auto', width: '75%', maxWidth: '750px' }}>
          <form onSubmit={handleSubmit}>
            <div style={{ textAlign: 'center', fontSize: '14px', margin: '5px 0px 20px' }}>
              If the applicant is applying in person, use the form below to complete their
              application.
            </div>

            <Header name="Applicant Information" />

            <PersonalDetails {...this.props} />

            <Header name="Rental History Questions" />

            <RentalHistoryQuestions />

            <Header name="Currently Living Address" />

            <div style={{ marginBottom: '25px' }}>
              <AddressFormFields {...this.props} />
            </div>

            <Header name="Occupation Details" />

            <div style={{ marginBottom: '15px' }}>
              <CurrentOccupation {...this.props} />
            </div>

            <Header name="Other Details" />

            <div style={{ marginBottom: '25px' }}>
              <EmergencyContacts startDeletingAtIndex={1} {...this.props} newMUI />
            </div>

            {this.props.showTenantAdditionalOccupant && (
              <div style={{ marginBottom: '15px' }}>
                <OtherOccupants {...this.props} />
              </div>
            )}

            {this.props.showTenantPetDetails && (
              <div style={{ marginBottom: '15px' }}>
                <Pets {...this.props} />
              </div>
            )}
            <div style={{ marginBottom: '15px' }}>
              <Vehicles {...this.props} />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <LandlordReferences {...this.props} />
            </div>
            <div style={{ marginBottom: '15px' }}>
              <PersonalReferences {...this.props} />
            </div>
            <Header name="Documents" />
            <div style={{ marginBottom: '25px' }}>
              <AddDocumentOfProofs />
            </div>
          </form>
        </div>
      </MuiThemeProvider>
    );
  }
};

const FORM_NAME = 'manual_applicant_form';
const selector = formValueSelector(FORM_NAME);
ManualApplicantForm = compose(
  connect(
    state => ({
      isStudent: selector(state, 'is_student'),
      hasWorkExperience: selector(state, 'has_work_experience'),
      hasEmergencyContact: selector(state, 'has_emergency_contact'),
      showTenantAdditionalOccupant: state.userTypes.showTenantAdditionalOccupant,
      showTenantPetDetails: state.userTypes.showTenantPetDetails,
      minimumApplicantAge: state.companyDetails.companyPreferences.minimum_applicant_age,
      collectLeadSinNumberDuringApplication:
        state.companyDetails.companyPreferences.collect_lead_sin_number_during_application,
    }),
    null
  ),
  reduxForm({
    form: FORM_NAME,
    validate,
  })
)(ManualApplicantForm);

export default ManualApplicantForm;
